import React from 'react';
import { normalizeToSelect } from 'util/converters';
import {
  ROLE_ACCOUNTANT,
  PROFILE_ACCOUNTANT,
  ROLE_USER,
  PROFILE_USER,
  ROLE_CLINIC_ADMINISTRATOR,
  PROFILE_ADMINISTRADOR,
  ROLE_PROFESSIONAL,
  PROFILE_DOCTOR,
  ROLE_OTHER_HEALTH_PROFESSIONAL,
  PROFILE_OTHER,
  ROLE_STUDENT,
  PROFILE_STUDENT,
  ROLE_RECEPTIONIST,
  PROFILE_RECEPTIONIST,
  ROLE_FINANCIAL,
  PROFILE_FINANCIAL,
  ROLE_PARTNERSHIP,
  PROFILE_PARTNERSHIP,
  ROLE_FINANCIAL_ADMINISTRATOR,
  PROFILE_FINANCIAL_ADMINISTRATOR,
  ROLE_STOCK,
  ROLE_ADMIN
} from 'constants/types';
import { Select } from 'antd';
import roles from '../constants/roles';
import SelectWrapperPrefix from './SelectWrapperPrefix';

function getProfileByRole(role) {
  switch (role) {
    case ROLE_ACCOUNTANT:
      return PROFILE_ACCOUNTANT;
    case ROLE_USER:
      return PROFILE_USER;
    case ROLE_CLINIC_ADMINISTRATOR:
      return PROFILE_ADMINISTRADOR;
    case ROLE_PROFESSIONAL:
      return PROFILE_DOCTOR;
    case ROLE_OTHER_HEALTH_PROFESSIONAL:
      return PROFILE_OTHER;
    case ROLE_STUDENT:
      return PROFILE_STUDENT;
    case ROLE_RECEPTIONIST:
      return PROFILE_RECEPTIONIST;
    case ROLE_FINANCIAL:
      return PROFILE_FINANCIAL;
    case ROLE_PARTNERSHIP:
      return PROFILE_PARTNERSHIP;
    case ROLE_FINANCIAL_ADMINISTRATOR:
      return PROFILE_FINANCIAL_ADMINISTRATOR;
    default:
      return null;
  }
}

function getHiddenRoles(visibleRoles) {
  const allRoles = [
    ROLE_ADMIN,
    ROLE_PROFESSIONAL,
    ROLE_RECEPTIONIST,
    ROLE_USER,
    ROLE_STUDENT,
    ROLE_OTHER_HEALTH_PROFESSIONAL,
    ROLE_CLINIC_ADMINISTRATOR,
    ROLE_FINANCIAL,
    ROLE_ACCOUNTANT,
    ROLE_PARTNERSHIP,
    ROLE_FINANCIAL_ADMINISTRATOR,
    ROLE_STOCK
  ];

  return allRoles.filter((role) => !visibleRoles.includes(role));
}

const getOptions = (segment, useProfileId = true) => {
  if (!segment?.roles) {
    return [];
  }

  return segment?.roles.map((item) => {
    const role = roles.find((r) => r.id === item.role.id);

    return {
      id: useProfileId ? getProfileByRole(role?.name) : role?.id,
      name: role?.name,
      description: item?.name
    };
  });
};

const SegmentProfileSelect = ({ segment, prefix, ...rest }) => {
  if (!prefix) {
    return (
      <Select {...rest}>
        {getOptions(segment).map((c) => {
          return (
            <Select.Option key={c.id} value={c.id} title={c.description}>
              {c.description}
            </Select.Option>
          );
        })}
      </Select>
    );
  }

  return (
    <SelectWrapperPrefix prefix={prefix} {...rest}>
      <Select>
        {getOptions(segment).map((c) => {
          return (
            <Select.Option key={c.id} value={c.id} title={c.description}>
              {c.description}
            </Select.Option>
          );
        })}
      </Select>
    </SelectWrapperPrefix>
  );
};

const SegmentRoleSelect = ({
  onChange,
  segment,
  hidePermissions = [],
  ...rest
}) => {
  if (!rest.value) {
    rest.value = [];
  }

  const handleTrigger = (newValue) => {
    onChange(roles.filter((c) => newValue.includes(c.id)));
  };

  const value = (rest.value ?? []).map((c) => c.id);

  const options = getOptions(segment, false);

  return (
    <Select {...rest} value={value} onChange={handleTrigger}>
      {options.map((c) => (
        <Select.Option key={c.id} value={c.id}>
          {c.description}
        </Select.Option>
      ))}
    </Select>
  );
};

export {
  getProfileByRole,
  SegmentProfileSelect,
  getHiddenRoles,
  SegmentRoleSelect
};
